// src/store/modules/search.js

import { fetchOffers } from '../../api/search';

const state = {
  user: null,
  message: ''
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_MESSAGE(state, message) {
    state.message = message;
  },
  setOffers: (state, offers) => (state.offers = offers)
};

const actions = {
  async fetchOffers({ commit }) {
    try {
      const response = await fetchOffers();
      commit('setOffers', response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des offres:", error);
    }
  }
};


export default {
  namespaced: true,
  state,
  mutations,
  actions
};